<svg
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  width={40}
  height={40}
  class="user-select-none cursor-pointer"
  viewBox="0 0 40 40">
  <circle cx="20" cy="20" r="20" fill="#F7F7F7" />
  <path
    d="m26.3511
    20.1238-.1233.1069.078.1425v.0001c.13.2374.1975.504.1962.7747m-.1509-1.0242-6.6238-2.6628h.5006m6.1232
    2.6628.0024-.0022c.348-.3058.5527-.7463.5527-1.2153
    0-.567-.3231-1.0789-.8013-1.3718l-.1202-.0735h-5.7568m6.1232
    2.6628-6.1474-2.1628m6.2983 3.187c-.0005.4671-.2043.9104-.5545
    1.2154l-.0007.0006-.1233.107.078.1425c.13.2375.1975.5041.1962.7747m.4043-2.2402v-.0015h-.5l.4999.0028c0-.0004.0001-.0009.0001-.0013Zm-.4043
    2.2402c-.0005.4672-.2043.9104-.5545
    1.2154l-.0007.0007-.1233.1069.078.1425c.13.2375.1975.504.1962.7747m.4043-2.2402v-.0015h-.5l.4999.0029c.0001-.0005.0001-.0009.0001-.0014Zm-.4043
    2.2402c-.0006.6357-.3755 1.2067-.9507
    1.4661l-.0981.0442h-8.7188v-6.1752l.018-.0653
    1.9434-7.041.0002-.0007c.0792-.2853.2492-.5369.4843-.7168.235-.1799.5223-.2783.8183-.2803h.0034c.2421
    0 .4974.0698.7121.2308l-.3.4m6.0879
    12.1382v-.0014h-.5l.5.0028v-.0014Zm-6.0879-12.1382.2993-.4004c.3231.2414.5054.6179.4852
    1.021v-.0007l-.4994-.0241.4994.0251-.1621
    3.3499m-.6224-3.9708c-.1172-.0878-.2637-.1308-.4121-.1308-.1873.0012-.3691.0635-.5178.1773-.1488.1139-.2563.2731-.3065.4535l1.2364-.5Zm.6224
    3.9708-.0242.5m0 0h5.6401c.3476.2128.5624.5722.5624.9453 0
    .3222-.1406.6269-.3828.8398l-.4277.3711-5.392-2.1562Zm6.7003
    2.1611-.1531.2024.0729.243c.0557.1856.0848.3824.0883.5849-.0009.4413-.1462.8653-.4085
    1.2119l-.1531.2024.0729.243c.0562.1871.0844.3809.0844.579 0
    .4427-.1454.8682-.4085
    1.2158l-.1531.2024.0729.243c.0562.1872.0844.3809.0844.579 0 .8073-.4798
    1.5346-1.2254
    1.8526l-.0028.0012c-.0966.0419-.2043.0642-.3187.0642H12.8125c-.0696
    0-.125-.0555-.125-.125v-7.1094c0-.0695.0554-.125.125-.125H15.7185l.1013-.3669
    1.6778-6.0742.0001-.0003c.2097-.7613.9105-1.2949
    1.7015-1.2949h.0019c.2163-.0008.4306.0428.6294.128.1989.0853.3782.2104.5267.3677l.0008.0008c.3045.3209.4603.7387.4395
    1.1826-.0001.0002-.0001.0003-.0001.0005l-.1171
    2.3995-.0256.5244H25.8637c.1465-.0001.2902.0389.4165.1129.6446.3782 1.0323
    1.0488 1.0323 1.7387 0 .4427-.1454.8682-.4085 1.2158Zm-13.8102
    6.5185v.5h2.582v-6.5468h-2.582v6.0468Z"
    fill="#8F92A1"
    stroke="#8F92A1" />
</svg>
